import Vue from 'vue'
import Router from 'vue-router'
import header from '../components/header'
import home from '../components/home'
import footer from '../components/footer'

Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        components: {
            header: header,
            home: home,
            footer: footer
        },
        beforeEnter(to, from, next) {
            [].forEach.call(document.getElementsByTagName('li'), function (item) { item.className = '' });
            next();
        }
    }],
    scrollBehavior(to, from, savedPosition) {
        console.log(to, from, savedPosition);
        return { x: 0, y: 0 };
    },
    mode: 'hash'
})



// WEBPACK FOOTER //
// ./src/router/index.js